import axios from "axios";
import { configUrl } from "config.js";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import { useQuery } from "react-query";


export default function useGetAllConfigurations(configType, isActive, isContentProvider) {
  const { providerType } = useContext(LoginContext)
  return useQuery("GetAllTargetAudience", async () => {
    if (configType == null) {
      console.log(configType);
      return null;
    }
    if (isActive == undefined || isActive == "") {
      isActive = false;
    }
    if (isContentProvider == undefined) {
      if (providerType == 1 || providerType == 3) {
        isContentProvider = true;
      } else {
        isContentProvider = false;
      }
    }
    let response = await axios.get(
      `${configUrl.AssessmentServer}/api/DemoghraphicInformation/${configType}/${isContentProvider}/${isActive}/${true}`
    );
    return response.data["$values"];
  },
    {
      staleTime: 1000 * 60 * 5,
    });
}
